import { render, staticRenderFns } from "./adminLogin.vue?vue&type=template&id=0c0e573b&scoped=true&"
import script from "./adminLogin.vue?vue&type=script&lang=js&"
export * from "./adminLogin.vue?vue&type=script&lang=js&"
import style0 from "./adminLogin.vue?vue&type=style&index=0&id=0c0e573b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e573b",
  null
  
)

export default component.exports